import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_follow_any_of_the_following_practices_related_to_o'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_follow_any_of_the_following_practices_related_to_o',
  name: 'Does the facility follow any of the following practices related to other types of written terms and conditions documents?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'SIGNED_COPIES_OF_TERMS_AND_CONDITIONS_DOCUMENTS_BETWEEN_THE_FAC',
      text: 'Signed copies of terms and conditions documents between the facility and each worker are maintained on file',
      externalIds: [
        {
          id: 'ep-3--5-1x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TERMS_AND_CONDITIONS_DOCUMENTS_ARE_UP_TO_DATE',
      text: 'Terms and conditions documents are up to date',
      externalIds: [
        {
          id: 'ep-3--5-2x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TERMS_AND_CONDITIONS_DOCUMENTS_CLEARLY_AND_ACCURATELY_STATE_THE',
      text: 'Terms and conditions documents clearly and accurately state the terms and conditions of employment',
      externalIds: [
        {
          id: 'ep-3--5-3x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COPIES_OF_TERMS_AND_CONDITIONS_DOCUMENTS_ARE_PROVIDED_TO_WORKER',
      text: 'Copies of terms and conditions documents are provided to workers',
      externalIds: [
        {
          id: 'ep-3--5-6x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ep-3--5-10x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'SIGNED_COPIES_OF_TERMS_AND_CONDITIONS_DOCUMENTS_BETWEEN_THE_FAC',
                'TERMS_AND_CONDITIONS_DOCUMENTS_ARE_UP_TO_DATE',
                'TERMS_AND_CONDITIONS_DOCUMENTS_CLEARLY_AND_ACCURATELY_STATE_THE',
                'COPIES_OF_TERMS_AND_CONDITIONS_DOCUMENTS_ARE_PROVIDED_TO_WORKER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-emp-5',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6080,
  sectionId: '2.2.4',
  impactArea: 'Contracts and HR',
  impactAreaId: 'CONTRACTS_AND_TERMS_OF_EMPLOYMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
